import React, { forwardRef,useRef, useState } from "react";
import OutsideClickHandler from 'react-outside-click-handler';
import SpeechRecognition from "react-speech-recognition";
import TextareaAutosize from "react-textarea-autosize";
import Picker from "emoji-picker-react";

import { requestNotification } from '../Services/HWIframeBridge';
import { s360ConfigService } from "../Services/S360Config";

import TextToSpeech from "./TextToSpeech";

import "./ConversationStyleSheet.css";

function InputBox(props, ref){
  const microphoneRef = useRef();
  const [textValue, setTextValue] = useState(localStorage.getItem("finalvalue") ?? "");
  const [sent, setSent] = useState(true);
  const [showEmoji, setShowEmoji] = useState(false);
  const isFullScreen = localStorage.getItem("openInFullScreen");
  const { disableInput, attchmentProps } = props;
  const { attachRef, onClickAttachment, onChangeAttachment } = attchmentProps;

  const defaultMessage = props.disableInput
    ? "Not allowed while uploading documents."
    : "Type a message...";

  const handleClick = () => {
    setShowEmoji(false);
    if (!s360ConfigService?.config?.sandBox) {
      props.send();
      setTextValue("");
      setSent(!sent);
      localStorage.removeItem("finalvalue");
    }
  };

  const containerStyle = () => {
    return {
      width: s360ConfigService?.config?.sandBox ? '95%' : '95%',
      borderColor: "#ccc",
      color: "black",
      cursor: props.disableInput ? "not-allowed" : "text",
      ...s360ConfigService.config?.customDesign?.inputBoxInputContainer
    };
  };

  const onTextFieldChange = (e) => {
    setTextValue(e.target.value);
  };

  const handleKeyPress = (event) => {
    if (s360ConfigService?.config?.sandBox) {
      if (event.key === "Enter") {
        setShowEmoji(false);
        document.getElementById("tx1").value = "";
        event.preventDefault()
      }
    } else {
      if (event.key === "Enter") {
        setShowEmoji(false);
        event.preventDefault();
        props.send();
        setTextValue("");
        setSent(!sent);
      }
    }

    console.log('are you handleKeyPress')

    if (!s360ConfigService?.config?.sandBox && 
      s360ConfigService.config?.configDetails?.browserNotification
       && Notification.permission !== "granted") {
      console.log('are you requesrting a notification')
      requestNotification();
    }
  };

  const emojiImage = () => (
    <svg width="20" height="20" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.5 9C14.5 6.6875 13.25 4.5625 11.25 3.375C9.21875 2.21875 6.75 2.21875 4.75 3.375C2.71875 4.5625 1.5 6.6875 1.5 9C1.5 11.3438 2.71875 13.4688 4.75 14.6562C6.75 15.8125 9.21875 15.8125 11.25 14.6562C13.25 13.4688 14.5 11.3438 14.5 9ZM0 9C0 6.15625 1.5 3.53125 4 2.09375C6.46875 0.65625 9.5 0.65625 12 2.09375C14.4688 3.53125 16 6.15625 16 9C16 11.875 14.4688 14.5 12 15.9375C9.5 17.375 6.46875 17.375 4 15.9375C1.5 14.5 0 11.875 0 9ZM5.53125 10.9688C6 11.4688 6.8125 12 8 12C9.15625 12 9.96875 11.4688 10.4375 10.9688C10.7188 10.6562 11.1875 10.625 11.5 10.9062C11.8125 11.1875 11.8125 11.6562 11.5312 11.9688C10.8438 12.7188 9.65625 13.5 8 13.5C6.3125 13.5 5.125 12.7188 4.4375 11.9688C4.15625 11.6562 4.1875 11.1875 4.46875 10.9062C4.78125 10.625 5.25 10.6562 5.53125 10.9688ZM4.5 7.5C4.5 6.96875 4.9375 6.5 5.5 6.5C6.0625 6.5 6.5 6.96875 6.5 7.5C6.5 8.0625 6.0625 8.5 5.5 8.5C4.9375 8.5 4.5 8.0625 4.5 7.5ZM10.5 6.5C11.0625 6.5 11.5 6.96875 11.5 7.5C11.5 8.0625 11.0625 8.5 10.5 8.5C9.9375 8.5 9.5 8.0625 9.5 7.5C9.5 6.96875 9.9375 6.5 10.5 6.5Z"
        fill="#758BA3"
      />
    </svg>
  )

  const attachmentImage = () => (
    <svg width="18" height="18" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6289 2.74609C9.91797 2.03516 8.74219 2.03516 8.03125 2.74609L2.80859 7.99609C1.60547 9.19922 1.60547 11.1406 2.80859 12.3164C3.98438 13.5195 5.92578 13.5195 7.12891 12.3164L11.2852 8.16016C11.5312 7.91406 11.9414 7.91406 12.1875 8.16016C12.4609 8.43359 12.4609 8.84375 12.1875 9.08984L8.05859 13.2461C6.33594 14.9688 3.57422 14.9688 1.87891 13.2461C0.15625 11.5508 0.15625 8.78906 1.87891 7.06641L7.12891 1.81641C8.33203 0.613281 10.3281 0.613281 11.5586 1.81641C12.7617 3.04688 12.7617 5.04297 11.5586 6.24609L6.52734 11.2773C5.65234 12.1523 4.23047 12.0703 3.46484 11.1133C2.80859 10.293 2.89062 9.11719 3.62891 8.37891L7.78516 4.22266C8.03125 3.97656 8.44141 3.97656 8.6875 4.22266C8.96094 4.49609 8.96094 4.90625 8.6875 5.15234L4.55859 9.30859C4.28516 9.58203 4.25781 9.99219 4.50391 10.293C4.77734 10.6211 5.26953 10.6758 5.59766 10.3477L10.6289 5.31641C11.3398 4.60547 11.3398 3.45703 10.6289 2.74609Z"
        fill="#758BA3"
      />
    </svg>
  )

  const sendImage = () => (
    <svg width="24" height="24" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M49.9141 13.6797L44.4141 49.3438C44.3281 50.2031 43.8125 50.9766 43.0391 51.4062C42.6094 51.5781 42.1797 51.75 41.6641 51.75C41.3203 51.75 40.9766 51.6641 40.6328 51.4922L30.1484 47.1094L25.7656 53.6406C25.4219 54.2422 24.8203 54.5 24.2188 54.5C23.2734 54.5 22.5 53.7266 22.5 52.7812V44.5312C22.5 43.8438 22.6719 43.2422 23.0156 42.8125L41.75 18.75L16.4844 41.5234L7.63281 37.8281C6.6875 37.3984 6 36.5391 6 35.4219C5.91406 34.2188 6.42969 33.3594 7.375 32.8438L45.875 10.9297C46.7344 10.4141 47.9375 10.4141 48.7969 11.0156C49.6562 11.6172 50.0859 12.6484 49.9141 13.6797Z"
        fill="#758BA3"
      />
    </svg>
  );
  const handleEmoji=(event,emojiObject)=>{
    var preText = textValue;
    var emoji = emojiObject.emoji;
    setTextValue(preText+emoji)

  }
  return (
    <div>
      <OutsideClickHandler
        onOutsideClick={() => {
          setShowEmoji(false);
        }}
      >
        {showEmoji && (
          <Picker
            disableSkinTonePicker
            onEmojiClick={handleEmoji}
            groupVisibility={{
              flags: false,
              animals_nature: false,
              food_drink: false,
              travel_places: false,
              activities: false,
              objects: false,
              symbols: false,
            }}
            pickerStyle={{
              position: "absolute",
              top: "115px",
              left: "9px",
              width: "93%",
              zIndex: "99999",
            }}

          />
        )}
        <div className={`s360-conversation-input-box-container${isFullScreen ? "-fs" : ""}`}>
          <div
            className={`s360-input-box-input-container${isFullScreen ? "-fs" : ""}`}
            id="tx"
            style={containerStyle()}
          >
            <TextareaAutosize
              disabled={disableInput}
              ref={ref}
              id="tx1"
              value={textValue}
              className="s360-input-box-input"
              placeholder={defaultMessage}
              type="text"
              onChange={onTextFieldChange}
              onKeyDown={handleKeyPress}
              style={{
                backgroundColor: "white",
                fontSize: "14px",
                cursor: disableInput ? "not-allowed" : "default",
                opacity: disableInput ? 0.2 : 1,
              }}
            />

            {SpeechRecognition.browserSupportsSpeechRecognition() && (
              <div
                className="s360-input-box-micro"
                ref={microphoneRef}
                id="gif"
                style={{
                  marginBottom: 0,
                  cursor: disableInput ? "not-allowed" : "default",
                  opacity: disableInput ? 0.2 : 1,
                }}
              >
                {props?.config?.allowMicrophone && (
                  <TextToSpeech textValue={textValue} setTextValue={setTextValue} sent={sent} {...props} />
                )}
              </div>
            )}
            <div className="s360-input-box-image-container" id="img2">
              {!s360ConfigService?.config?.preview && <div className={`s360-new-conversation-tab-image1${isFullScreen ? "-fs" : ""}`}
                onClick={()=>setShowEmoji(!showEmoji)}>
                {emojiImage()}
              </div>}
              {s360ConfigService?.config?.sandBox ? s360ConfigService?.config?.hideAttachment : sessionStorage.getItem("agentConnected") &&(
                <div className={`s360-new-conversation-tab-image1${isFullScreen ? "-fs" : ""}`}
                  onClick={onClickAttachment}>
                  <input
                    style={{ opacity: "0", width: "1px", display: "none" }}
                    ref={attachRef}
                    type="file"
                    multiple="multiple"
                    onChange={onChangeAttachment}
                    className="UploadFile image_uploader"
                  />
                  {attachmentImage()}
                </div>
              )}
              <div className={`s360-new-conversation-tab-image1${isFullScreen ? "-fs" : ""}`}
                onClick={handleClick}>
                {sendImage()}
              </div>
            </div>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
}

export default forwardRef(InputBox);
